module.exports = __webpack_public_path__ + "static/media/oracle_logo.8dd434fb.png";